export const state = {
  __snippets: null,
  __myElements: {},
  __currentSettings: {},
};
